import { action, computed, makeObservable, observable } from 'mobx';

import type { TFormMessageType } from './form-message.entity';
import { FormMessage } from './form-message.entity';

export class FormMessagesService {
  @observable errorMessages: FormMessage[] = [];

  constructor() {
    makeObservable(this);
  }

  @computed
  get messages(): FormMessage[] {
    return this.errorMessages;
  }

  @action.bound
  addMessage(text: string, type: TFormMessageType): void {
    switch (type) {
      case 'error': {
        const newMessage = new FormMessage(text, type);

        this.errorMessages.push(newMessage);
      }
    }
  }

  @action.bound
  deleteMessage(key: number | string, type: TFormMessageType): void {
    switch (type) {
      case 'error': {
        const index = this.errorMessages.findIndex((mes) => mes.entityId === key);

        if (index < 0) {
          return;
        }

        const copiedMessages = [...this.errorMessages];
        copiedMessages.splice(index, 1);

        this.errorMessages = copiedMessages;
      }
    }
  }
}
